import {
  ROUTE_DIVISION_START,
  ROUTE_DIVISION_BY_AREA_START,
  ROUTE_DIVISION_STARTED,
  ROUTE_DIVISION_ERROR,
  ROUTE_DIVISION_RESET,
  RouteDivisionActions,
} from "../actions/routeDivisionActions";

type RouteDivisionState = {
  isSubmitting: boolean;
  error: string | null;
  succeeded: boolean;
};

const initialState: RouteDivisionState = {
  isSubmitting: false,
  error: null,
  succeeded: false,
};

export const routeDivisionReducer = (
  state = initialState,
  action: RouteDivisionActions
): RouteDivisionState => {
  switch (action.type) {
    case ROUTE_DIVISION_START:
    case ROUTE_DIVISION_BY_AREA_START:
      return {
        ...state,
        isSubmitting: true,
        error: null,
        succeeded: false,
      };
    case ROUTE_DIVISION_STARTED:
      return {
        ...state,
        isSubmitting: false,
        error: null,
        succeeded: true,
      };
    case ROUTE_DIVISION_ERROR:
      return {
        ...state,
        isSubmitting: false,
        error: action.payload,
      };
    case ROUTE_DIVISION_RESET:
      return initialState;
    default:
      return state;
  }
};
